module.exports = __webpack_public_path__ + "img/movie.734d2db4.png";